import { useInfiniteQuery } from 'react-query';
import { EXPRESS_API } from 'configs/api/expressApi';
import { customerKeys } from './queryKeys';
import { useToastError } from 'lib/hooks';

export interface ICustomersByResellerParams {
  skip?: number;
  take?: number;
  hasBusiness?: boolean;
  search?: string;
  customerId: number;
}

const getAllCustomersForReseller = async (
  params: ICustomersByResellerParams
) => {
  return (
    await EXPRESS_API.get(`customers/${params.customerId}/getByReseller`, {
      params: {
        skip: params?.skip || 0,
        take: params?.take || 100,
        search: params?.search || '',
        hasBusiness: params?.hasBusiness,
      },
    })
  ).data;
};

export const useInfiniteCustomersByResellerQuery = ({
  params,
  enabled,
}: {
  params: ICustomersByResellerParams;
  enabled: boolean;
}) => {
  const { showError } = useToastError();
  return useInfiniteQuery(
    customerKeys.customers_by_reseller(params),
    () => getAllCustomersForReseller(params),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: enabled,
      keepPreviousData: true,
      onError: () => {
        showError(
          'An error occurred while fetching customer information. Please try again later.'
        );
      },
    }
  );
};
